export function checkTypePhoto(file) {
  const typeImg = 'image/jpeg, image/jpg, image/png, image/jfif'
  if (!['jpeg', 'jpg', 'png', 'jfif'].includes(file.name.split('.').reverse()[0]) || !file.type || typeImg.indexOf(file.type) === -1) {
    return true;
  } else {
    return false;
  }
}
